<template>
  <div id="main">
    <v-index>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>设定</el-breadcrumb-item>
        <el-breadcrumb-item><a style="color: #000000;">专业</a></el-breadcrumb-item>
      </el-breadcrumb>

      <v-weburl-iframe url="setting/major" />
    </v-index>
  </div>
</template>

<script>
import VIndex from "@/components/common";
import VWeburlIframe from "@/components/weburl-iframe";
export default {
  name: 'major',
  components: {VWeburlIframe, VIndex}
}
</script>

<style scoped>

</style>